import React from "react";
import { Helmet } from "react-helmet";
import InnerContactForm from "./InnerContactForm";
import InnerContactInfo from "./InnerContactInfo";

const InnerContactArea = () => {
  return (
    <section className="inner-contact-area">
      <Helmet>
        <title>Contact | Vernu Stoffering</title>
        <meta
          name="description"
          content="Neem contact op met Vernu Stoffering in Rotterdam voor al uw kledingreparaties, herstelwerk en maatwerk. Snel, professioneel en klantgericht."
        />
      </Helmet>

      <div className="container">
        <div className="inner-contact-wrap">
          <div className="row">
            <div className="col-xl-9 col-lg-10">
              <div className="section-title title-style-two mb-50">
                <h2 className="title">
                  Een vraag of afspraak? <span>Neem gerust contact op</span>
                </h2>
              </div>

              {/* Contactformulier wordt pas geactiveerd zodra klaar */}
              <div className="inner-contact-form-wrap">
                <InnerContactForm />
              </div>

              {/* Google Maps iframe – locatie aanpassen in volgende stap */}
              <div id="contact-map" className="mt-40">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2465.8222423408275!2d4.416213!3d51.922478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c433b68560c4ef%3A0x6c5e3459380a4c2e!2sAbtsweg%2041A%20-%2043A%2C%203042%20GA%20Rotterdam!5e0!3m2!1snl!2snl!4v1682888888888"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Locatie van Diana Kledingreparatie / Vernu Stoffering"
                ></iframe>
              </div>

              <div className="inner-contact-info mt-40">
                <InnerContactInfo />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnerContactArea;
